import {listTypes} from './enum';
import {formsStore} from '../../../../stores/Form';
import {EntityType} from '../../consts/EntityTypes';
import {actionZoom} from '../../actions/zoom';

export const mapListDataByType = (listType: listTypes) => {
    const {getActiveForm, currentScreen} = formsStore;
    const currentForm = getActiveForm();

    if (!currentForm) return [];

    if (listType === listTypes.FormSons) {
        return (
            currentForm?.subFormsList.map(item => ({
                title: item.Title,
                id: item.Ename,
                action: async () => {
                    return await currentScreen.runSubForm(item.Ename, currentForm, item.IsText);
                }
            })) || []
        );
    } else if (listType === listTypes.DirectActivations) {
        return (
            currentForm?.actions.map(item => ({
                title: item.Title,
                id: item.Ename,
                type: item.Type,
                action: async () => {
                    if (item.Type === EntityType.FORM) {
                        actionZoom(currentForm, item.Ename);
                    } else {
                        alert('Action handler placeholder');
                        // todo: add a correct action handlers
                    }
                }
            })) || []
        );
    } else if (listType === listTypes.DirectActivationsF) {
        return (
            currentForm?.actions
                .map(item => ({
                    title: item.Title,
                    id: item.Ename,
                    type: item.Type,
                    action: async () => {
                        await actionZoom(currentForm, item.Ename);
                    }
                }))
                .filter(item => item.type === EntityType.FORM) || []
        );
    }
    return [];
};

export const formHasActiveKeys = () => {
    const currentForm = formsStore.getActiveForm();
    if (currentForm && !currentForm.searchModeLevel) {
        const activeRow = currentForm.records[currentForm.currentRow];
        return activeRow?.keys;
    }
    return false;
};
